import { gql } from "@apollo/client";

export const VALIDAR_PEDIDO_CONEXION = gql`
    query validarPedidoConexion (
        $idEvaluacion: Int!,
        $fechaEnvio: CustomDateTime!
    ){
        validarPedidoConexion (
            idEvaluacion: $idEvaluacion,
            fechaEnvio: $fechaEnvio
        )
    }
`;